const isParentNavEnabled = false;
export default [
    {
        path: 'gpupload',
        name: 'gpupload',
        redirect: "home",
    },
    {
        path: 'home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "gpupload-home" */ '../views/Home.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: 'configurations',
        name: 'Configurations',
        component: () => import(/* webpackChunkName: "gpupload-configurations" */ '../views/Configurations.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: 'userassignment',
        name: 'UserAssignment',
        component: () => import(/* webpackChunkName: "gpupload-configurations" */ '../views/UserAssignment.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: 'auditlog',
        name: 'AuditLog',
        component: () => import(/* webpackChunkName: "gpupload-auditlog" */ '../views/AuditLog.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
]
